import { FC, PropsWithChildren, useEffect, useRef } from 'react';

import { initSentry } from '@/lib/initializers/sentry';
import { initEpisod } from '@/lib/utils/episod';
import { env } from '@/lib/env';

export const ConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const sentryInitializedRef = useRef(false);
  const episodInitializedRef = useRef(false);

  useEffect(() => {
    if (
      !env.SENTRY_DSN ||
      !env.SENTRY_ENVIRONMENT ||
      !env.SENTRY_RELEASE ||
      sentryInitializedRef.current
    ) {
      return;
    }

    sentryInitializedRef.current = true;
    initSentry(env.SENTRY_DSN, env.SENTRY_ENVIRONMENT, env.SENTRY_RELEASE);
  }, []);

  useEffect(() => {
    if (
      !env.EPISOD_URL ||
      !env.EPISOD_X_CLIENT_ID ||
      !env.EPISOD_COOKIE_DOMAIN ||
      episodInitializedRef.current
    ) {
      return;
    }

    episodInitializedRef.current = true;
    initEpisod({
      url: env.EPISOD_URL,
      xClientId: env.EPISOD_X_CLIENT_ID,
      cookieDomain: env.EPISOD_COOKIE_DOMAIN,
    });
  }, []);

  return <>{children}</>;
};

export default ConfigProvider;
